<template>
  <div class="register">
    <div class="register-box">
      <div class="register-head">
         <Head></Head>
       </div>
       <div class="register-main" v-if="this.verify == 'ok'">
           <img src="@/assets/success.jpg" alt=""><span>已激活,去<a class="active" @click="goLogin">登录</a> </span>
       </div>
       <div class="register-main-error" v-else>
          <i class="icon-span"><span>!</span></i><span>激活失败,请联系客服处理</span>
       </div>
    </div>
  </div>
</template>

<script>
import Head from "./components/activationCodehead"
import getUUID from '@/utils/getUUID'
export default {
  data(){
    return{
      verify : "notok"
    }
  },
  components:{
      Head
  },
  created() {
  function GetArgsFromHref(sHref, sArgName)
  {
      var args    = sHref.split("?");
      var retval = "";

      if(args[0] == sHref) /*参数为空*/
      {
          return retval; /*无需做任何处理*/
      }
      var str = args[1];
      args = str.split("&");
      for(var i = 0; i < args.length; i ++)
      {
          str = args[i];
          var arg = str.split("=");
          if(arg.length <= 1) continue;
          if(arg[0] == sArgName) retval = arg[1];
      }
      return retval;
  }
  // let urls = getUrlKey("verify",window.location.href)
  let urls = GetArgsFromHref(window.location.href,"verify")
  //请求激活接口
    this.$api.main.active({
      verify:urls
    }).then(res=>{
      if(res.status == 1){
        this.verify = "ok"
         this.$message.closeAll()
        this.$message.success('激活成功去登录')
      }else if(res.msg == '账号已激活，无需重复激活'){
        this.verify = "ok"
         this.$message.closeAll()
        this.$message.success('账号已激活去登录')
      }
    })
  },
  methods: {
    data () {
      this.isShow = !this.isShow
    },
    goLogin(){
        this.$router.push('/login')
    },
    goRegister(){
        this.$router.push('/register')
    }
  },
}
</script>

<style lang="less" scoped>
.register{
  width: 1920px;
  height:100vh;
  background: #ccc;
  position: relative;
  .register-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height:908px;
    width: 1200px;
    background: #fff;
    border-radius: 9px 9px 0px 0px;
    .register-head{
      width: 1200px;
      height:117px;
    }
    .register-main{
      width: 553px;
      height: 300px;
      color: #333333;
      margin-left: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 150px;
      span{
          text-align: center;
          margin-top: 30px;
          font-size:30px;
          a{
             font-style: normal;
             color: #ffbb00;
          }
      }
      .icon-span{
        display: inline-block;
        background-color: #fff;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 150px;
        height: 150px;
        vertical-align: middle;
    }
    .icon-span::after{
    border: 2px solid transparent;
    border-left: 0;
    border-top: 0;
        content: " ";
        top: 20px;
        left: 36px;
        font-weight: 700;
        position: absolute;
        width: 80px;
        height: 86px;
        -webkit-transform: rotate(45deg) scale(0);
        transform: rotate(45deg) scale(0);
        -webkit-transition: -webkit-transform .2s;
        transition: -webkit-transform .2s;
        transition: transform .2s;
        transition: transform .2s, -webkit-transform .2s;
        }
        .icon-span{
        background-color: green;
        border-color: #fff;
        }
        .icon-span::after{
        border-color: #fff;
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
        }
    }
     .register-main-error{
      width: 553px;
      height: 300px;
      color: #333333;
      margin-left: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 150px;
      span{
          text-align: center;
          margin-top: 30px;
          font-size:30px;
          a{
             color: #ffbb00;
          }
      }
      i{
           font-style: normal;
      }
      .icon-span{
        display: inline-block;
        border-radius: 100%;
        border: 1px solid #ccc;
        position: relative;
        width: 150px;
        height: 150px;
        vertical-align: middle; 
        background-color: red;
        border-color: #fff;
       span{
         position: absolute;
         left:40%;
         top:-30px;
         color:#fff;
         font-size: 100px;
         font-weight: 700px;
       }
    }
    }
  }
}
</style>